/**
 * Imports API
 */
import axios from 'axios';
import { API_URL } from '@/App.settings';

/**
 * Import Strategie de recherche
 */
import { SearchStrategy } from './SearchStrategy';

/**
 * Classes
 */
import BaseNode from '@/types/BaseNode';
import Dictionary from '@/types/Dictionary';

/**
 * Classe straégie sur la recherche d'objet de type INode via le composant de recherche Search
 */
export class NodeSearchStrategy extends SearchStrategy {

    protected override displayer = "NodeSearchDisplayer";
    protected override event = "NodeSelectedEvent";

    /**
     * Exécute l'appel API à 'FilterTree/SearchNode'.
     * @param parameters Les arguments nécessaires pour l'appel API (déjà formatés par le composant 'Search').
     * @returns Une promesse qui résout en un tableau de BaseNode.
     */
    protected async execute(parameters: Dictionary<any>): Promise<Array<BaseNode>> {
        return new Promise((resolve, reject) => {
            console.debug("Search - NodeSearchStrategy - parameters", parameters);
            axios.post(API_URL + 'FilterTree/SearchNode', parameters).then((response) => {
                if (response && response.data) {
                    console.debug("Search - NodeSearchStrategy - axiosResult", response.data);
                    
                    const result = response.data.map(item => {
                        return new BaseNode(item.Id, item.Name, item.Invariant, item.ObjectType, item.Location, item.IsDepreciated);
                    });

                    resolve(result);
                }
            });
        });
    }
}
